<template>
 <div class="mt-3">
  <h5>Fehler: 404</h5>
  <div class="mt-3">
   Diese Seite konnte nicht gefunden werden.
  </div>
 </div>
</template>
<script>

export default {
  name: 'NotFound',
  data () {
    return {
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/main/vue/components/NotFound.vue